// import axios from "axios";

// const AccumulatedService = {
//   GetActultimeduration: () =>
//     axios.get("Production/GetActultimeduration"),

//   GetJobHours: (data) =>
//     axios.get("Production/GetJobHours", data),
// };

// export default AccumulatedService;

import axios from "axios";

const AccumulatedService = {

  //GET – No body needed
  GetActultimeduration: () =>
    axios.get("Production/GetActultimeduration"),

  GetIwoGroupByAdditional: () =>
    axios.get("Production/GetIwoGroupByAdditional"),

  //GET with Query Params (for List<string> IwoList)
  GetJobHours: (iwoList) =>
    axios.get("Production/GetJobHours", {
      params: { IwoList: iwoList },
      paramsSerializer: (params) => {
        // Ensures proper array format: IwoList=8494&IwoList=8492
        return params.IwoList
          .map(iwo => `IwoList=${encodeURIComponent(iwo)}`)
          .join("&");
      },
    }),
};

export default AccumulatedService;
